import React from 'react';
import { connect } from 'react-redux';
import { detalleMapa, urlDirectorioBase,apiKeyMaps } from './directorio.act';

let esCliente = localStorage.getItem("esCliente") ? true: false;

const mapState = (state) => {
    return {
        paso: state.directorio.paso,
        servicio: state.directorio.servicios,
        filtrosM: state.directorio.medicos,
        filtrosH: state.directorio.hospitales,
        listaMedicos: state.directorio.listaMedicos,
        listaHospitales: state.directorio.listaHospitales,
        seleccionado: state.directorio.opcional,
        marcadoresFlag: state.directorio.marcadoresFlag,
        listaMarcadores: state.directorio.listaMarcadores,
    };
}


const mapDispatch = (dispatch) => {
    return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
        guardaDetalleMapa: (_item) => {
            dispatch(detalleMapa(_item));
        }
    }
}

const iconPosicion = require("../img/pin-map.png");
const iconPosicionLocal = require("../img/icon-ubicacion.png");
const ubicacionG = require("../img/localizaG.svg");
const ubicacionN = require("../img/localizaN.svg");
const info = require("../img/info.svg");


class Mapa extends React.Component {

    map = null;
    markerInfo = null;
    markerSelected = null;
    markerList = [];
    lista = [];
    flag = this.props.marcadoresFlag;

    componentDidMount = () => {
        this.getLocation();
        esCliente = localStorage.getItem("esCliente") ? true: false;
        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@ Es cliente: " + esCliente);
    }

    changeZoom = () => {
        this.map.setZoom(14);
        return true;
    }

    hidePoint = () => {
        if(this.markerSelected) {
            this.markerInfo.close();
            this.markerSelected.setAnimation(null);
        }
    }

    verificaNull = (elemento) => {
        let elem = elemento;
        if(!elem){
            return "";
        }

        if(elem == "NULL"){
            return "";
        }

        return elem;
    }

    showPoint = (_marker) => {
        let tmpDataHospital = ['nombre', 'calle', 'colonia', 'cp'].find((key) => {
            return [undefined, null, ''].includes(_marker.data[key]);
        });
        let tmpDataDoctor = ['nombre', 'apaterno', 'amaterno', 'nombre_especialidad', 'nombre_circulo'].find((key) => {
            return [undefined, null, ''].includes(_marker.data[key]);
        }); 
        let invalidObject = (this.props.servicio == "hospitales") ? tmpDataHospital : tmpDataDoctor; 
        if(!invalidObject){
            this.hidePoint();
        }
        _marker.setAnimation(google.maps.Animation.BOUNCE);
        let stringDisplay = '<div style="max-height: 1000px !important;"></div>';
        if(this.props.servicio == "medicos") {
            let cp = "";
            let telefono = "";

            stringDisplay = `<div class="select-location">
                                <p class="select-titulo">${_marker.data.nombre} ${_marker.data.apaterno} ${_marker.data.amaterno}</p> 
                                <p>${_marker.data.direccion}<br> Colonia ${_marker.data.colonia}<br> C.P. ${cp = !_marker.data.cp ? "" : _marker.data.cp} </p>
                                <p>Especialidad - ${_marker.data.nombre_especialidad} </p>
                                <p>Círculo - ${_marker.data.nombre_circulo} </p>
                                <p>Teléfono - ${telefono = _marker.data.telefono == "NULL" ? "" : _marker.data.telefono}</p>
                            </div>`;
        } else if(this.props.servicio == "hospitales") {
            if (!invalidObject) {
                let cp = "";
                let telefono = "";
                if (this.validaHospital1(_marker.data)) {
                    stringDisplay = `<div class="select-location">
                                    <p class="select-titulo pt-15">${_marker.data.nombre} </p> 
                                    <p><b>${_marker.data.calle}<br> Colonia ${_marker.data.colonia}<br> C.P. ${cp = !_marker.data.cp ? "" : _marker.data.cp}</b> </p>
                                    <p class="text-center pt-15" style="display:${esCliente ? "" : "none !important"}"><a id="ingresoHospitalario" class="orange-btn">Realizar Ingreso hospitalario</a></p>
                                </div>
                            `;
                } else {
                    stringDisplay = `<div>
                                    <div style="min-height: 60px !important;  background-color: #cacaca; font-family: Arial; font-size: 12px; color: #173d7b; padding: 5px; margin: 5px 0 5px; text-justify: inter-word; display: flex; align-items: center; display:${esCliente ? "" : "none !important"}">
                                         <img src=${info} alt="info"/>
                                         <p style="margin: 0 2px; text-align: justify; max-width : 200px !important;  ">El hospital seleccionado se encuentra fuera del nivel hospitalario contratado.</p>
                                     </div>
                                <div class="select-location">
                                    <p class="select-titulo pt-15">${_marker.data.nombre} </p> 
                                    <p><b>${_marker.data.calle}<br> Colonia ${_marker.data.colonia}<br> C.P. ${cp = !_marker.data.cp ? "" : _marker.data.cp}</b></p>
                                    <p class="text-center pt-15" style="display:${esCliente ? "" : "none !important"}"><a id="ingresoHospitalario" class="orange-btn">Realizar Ingreso hospitalario</a></p>
                                </div>  
                            </div>
                            `;
                }
            }
        }
        
        var $this =  this;

        
        if(this.props.servicio == "medicos" || this.props.servicio == "hospitales"){
            let _markerInfo = new google.maps.InfoWindow({content: stringDisplay});

            if (this.props.servicio == "hospitales" && !invalidObject) {
                google.maps.event.addListener( _markerInfo , 'domready' , function() {
                    document.getElementById("ingresoHospitalario").addEventListener('click', function(e) {
                        $this.reenviarIngresoHospitalario(_marker,$this.validaHospital(_marker.data));
                    })
                });
            }
            if (!invalidObject) {
                _markerInfo.open(this.map, _marker);
                this.markerInfo = _markerInfo;
                this.markerSelected = _marker;
                this.closeWindow(this.markerInfo, this.markerSelected);
            }
        }
        

    }


    reenviarIngresoHospitalario = (informacion,validaIngreso) => {
        
        let ingresoHospitalario = true;

        let valoresIngresoHospitalario = {
            "nombre" : informacion.data.nombre ,
            "latitud" : informacion.data.latitud ,
            "longitud" : informacion.data.longitud ,
            "razonsocial" : informacion.data.razonsocial ,
            "rfc" : informacion.data.rfc,
            "idhospital": informacion.data.idhospital,
            "idplan" : informacion.data.idplan,
            "planes" : informacion.data.planes,
            "validaIngreso" : validaIngreso,
        };

        this.props.ingresoHospitalario(ingresoHospitalario,JSON.stringify(valoresIngresoHospitalario));
    }

    closeWindow = (InfoWindow, marcador) => {
        google.maps.event.addListener(InfoWindow, 'closeclick', function(){
            //console.log("SI FUNCIONA");
            marcador.setAnimation(null);
            this.hidePoint();
            this.markerSelected = null;
        })
    }
    
    getPoint = () => {
        let $this =  this;
        if(this.props.servicio == "hospitales"){
            let id = this.props.seleccionado.idhospital;
            
            this.markerList.map((item, i) => {
                if(item.data.idhospital == id) {
                    this.showPoint(item);         
                }
            });
        }

        if(this.props.servicio == "medicos"){
            let id = this.props.seleccionado.rfc;
            
            this.markerList.map((item, i) => {
                if(item.data.rfc == id) {
                    this.showPoint(item);                
                }
            });
        }
    }

    validaHospital1 = (el) => {
        let planSeleccionado = parseInt(localStorage.getItem("planValue"));
        let valido = false;
        let planesCliente = localStorage.getItem("planesCliente").replace("|", "");
        let planesClienteArray = planesCliente.split("|");
        let str = "";
        for(let a = 0; a < planesClienteArray.length; a++) {
            str = str + planesClienteArray[a] + ",";
        }
        str = str.substring(0, str.length - 1);
        let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
        planesC.planesClientes.map((p) => {
            let planes = el.planes.split(",");
            for(let a = 0; a < planes.length; a++) {
                if(p.cvePlan > 22) {
                    if(Number(this.transformarPlanes(p.cvePlan)) === Number(planes[a]) || Number(p.cvePlan) === Number(planes[a])) {
                        valido = true;
                    }
                } else {
                    if(Number(p.cvePlan) === Number(planes[a])) {
                        valido = true;
                    }
                }
            }
        });
        return valido;
    }

    transformarPlanes(idPlan) {
        let planVerdadero = idPlan;
        let planesSubplanesJSON = JSON.parse(localStorage.getItem("planesSubplanesGNP"));
        try {
            planesSubplanesJSON.map((psj) => {
                if(psj.idplan !== idPlan) {
                    let subplanes = psj.subplanes;
                    if(subplanes !== "") {
                        let subplanesArray = subplanes.split(",");
                        for(let i = 0; i < subplanesArray.length; i++) {
                            if(Number(subplanesArray[i]) === Number(idPlan)) {
                                planVerdadero = psj.idplan;
                                break;
                            }
                        }
                    }
                }
            });
        } catch(e) {
            console.log(e);
        }
        return planVerdadero;
    }

    validaHospital = (el) => {
        let planSeleccionado = parseInt(localStorage.getItem("planValue"));
        let valido = ubicacionG;
        let planesCliente = localStorage.getItem("planesCliente").replace("|", "");
        let planesClienteArray = planesCliente.split("|");
        let str = "";
        for(let a = 0; a < planesClienteArray.length; a++) {
            str = str + planesClienteArray[a] + ",";
        }
        str = str.substring(0, str.length - 1);
        let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
        planesC.planesClientes.map((p) => {
            let planes = (el.planes) ? el.planes.split(",") : [];
            for(let a = 0; a < planes.length; a++) {
                if(p.cvePlan > 22) {
                    if(Number(this.transformarPlanes(p.cvePlan)) === Number(planes[a]) || Number(p.cvePlan) === Number(planes[a])) {
                        valido = ubicacionN;
                    }
                } else {
                    if(Number(p.cvePlan) === Number(planes[a])) {
                        valido = ubicacionN;
                    }
                }
            }
        });
        return {
            url: valido, // url
            scaledSize: new google.maps.Size(30, 45), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };
    }

    
    addMarker = (_item) => {
        var $this =  this;
        if(_item.latitud && _item.latitud != "" && _item.longitud && _item.longitud != ""){
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(_item.latitud), parseFloat(_item.longitud)),
                map: this.map,
                data: _item,
                icon: this.validaHospital(_item)
            });
            
            google.maps.event.addListener(marker, 'click', function() { 
                $this.showPoint(marker);
            });
            
            this.markerList.push(marker);
        }

        //console.log(_item);
		//Se recupera los atributos, latitud, longitud, idhospital y rfc, y se asignan a variables,
		//ya que se estaba perdiendo las referencias al entrar al if de la línea 167.s
		var lat = _item.latitud;
		var lon = _item.longitud;
		var calle  = _item.calle;
		var colonia = _item.colonia;
		var dir = _item.direccion;
		var idHospital = _item.idhospital;
		var rfc = _item.rfc;
		var cp = _item.cp;
		
        if(lat == "" && lon == ""){
            let direccion = "";
            if(this.props.servicio == "hospitales"){
                direccion = calle + " " + colonia;
            }

            if(this.props.servicio == "medicos"){
                direccion = dir + " " + colonia + " C.P."+ cp;
            }
            
            let direc = direccion.split(" ");
            let street = direc.join("+");
            $.ajax({
                method: "GET",
                url: "https://maps.googleapis.com/maps/api/geocode/json",
                data: { address: street, components: "country:MX|postal_code:"+cp, key: apiKeyMaps },
                dataType: "json",
                success: (data) => {                    
                    if(data.status == "OK"){
                        let lat = data.results[0].geometry.location.lat;
                        let lng = data.results[0].geometry.location.lng;
                        let marker = new google.maps.Marker({
                            position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
                            map: this.map,
                            data: _item,
                            icon: iconPosicion
                        });
                        
                        google.maps.event.addListener(marker, 'click', function() { 
                            $this.showPoint(marker);
                        });
                        
                        this.markerList.push(marker);
                        let urlPOST = "";
                        if(this.props.servicio == "hospitales"){
                            urlPOST = urlDirectorioBase+"/directorios/hospitales/actualiza";
                            data = { latitud: lat, longitud: lng, idhospital: idHospital };
                        }

                        if(this.props.servicio == "medicos"){
                            urlPOST = urlDirectorioBase+"/directorios/medicos/actualiza";
                            data = { latitud: lat, longitud: lng, rfc: rfc };
                        }

                        let enviar = JSON.stringify(data);
                        $.ajax({
                            type: "POST",
                            url: urlPOST,
                            data: enviar,
                            contentType: "application/json",
                            dataType: "json",
                            success: (data) => {
                                console.log(data);
                            },
                            error: (error) => {
                                console.log(error);
                            }
                        });
                    }
                },
                error: (error) => {
                    console.log(error);
                }
            })
        }
        
    }

    CenterControl = (control, map, lat, lng) => {
        let controlWrapper = document.createElement('div');
        controlWrapper.style.backgroundColor = 'white';
        controlWrapper.style.borderStyle = 'solid';
        controlWrapper.style.borderColor = '#edece6';
        controlWrapper.style.borderWidth = '1px';
        controlWrapper.style.cursor = 'pointer';
        controlWrapper.style.textAlign = 'center';
        controlWrapper.style.width = '32px'; 
        controlWrapper.style.height = '64px';
        control.appendChild(controlWrapper);

        let targetButton = document.createElement('div');
        targetButton.style.width = '32px'; 
        targetButton.style.height = '32px';
        targetButton.style.backgroundSize = 'contain';
        targetButton.style.backgroundImage = 'url("'+require("../img/target.png")+'")';
        controlWrapper.appendChild(targetButton);

        let zoomInButton = document.createElement('div');
        zoomInButton.style.width = '32px'; 
        zoomInButton.style.height = '32px';
        zoomInButton.style.backgroundSize = 'contain';
        zoomInButton.style.backgroundImage = 'url("'+require("../img/mas.png")+'")';
        controlWrapper.appendChild(zoomInButton);

        let zoomOutButton = document.createElement('div');
        zoomOutButton.style.width = '32px'; 
        zoomOutButton.style.height = '32px';
        zoomOutButton.style.backgroundSize = 'contain';
        zoomOutButton.style.backgroundImage = 'url("'+require("../img/menos.png")+'")';
        controlWrapper.appendChild(zoomOutButton);

      

        google.maps.event.addDomListener(zoomInButton, 'click', function() {
            map.setZoom(map.getZoom() + 1);
        });

        google.maps.event.addDomListener(zoomOutButton, 'click', function() {
            map.setZoom(map.getZoom() - 1);
        });  

        google.maps.event.addDomListener(targetButton, 'click', function() {
            map.setCenter({lat: lat, lng: lng});
        });
    }

    loadMapa = (latlng) => {
        this.map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: latlng.latitude, lng: latlng.longitude},
            zoom: 12,
            styles: [
                {elementType: 'geometry', stylers: [{color: '#FAFAFA'}]},
                {elementType: 'labels.text.stroke', stylers: [{color: '#FFFFF'}]},
                {elementType: 'labels.text.fill', stylers: [{color: '#8A8A8A'}]},
                {featureType: 'road', elementType: 'geometry', stylers: [{color: '#EAEAEA'}]},
                {featureType: 'road', elementType: 'geometry.stroke', stylers: [{color: '#EAEAEA'}]},
                {featureType: 'water',elementType: 'geometry',stylers: [{color: '#F0F8FF'}]}
            ],
            disableDefaultUI: true,
            /*mapTypeControlOptions: {
                mapTypeIds: ['roadmap']
            }*/
        });

        let centerControlDiv = document.createElement('div');
        let centerControl = new this.CenterControl(centerControlDiv, this.map, latlng.latitude, latlng.longitude);
        centerControlDiv.index = 1;
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(centerControlDiv);

    }

    getLocation = () => {
        let $this = this;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(data){
                if (!$this.map) $this.loadMapa(data.coords);
                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(parseFloat(data.coords.latitude), parseFloat(data.coords.longitude)),
                    map: $this.map,
                    data: data,
                    icon: iconPosicionLocal
                });
                
                $this.showPoint(marker);
            }, function(error){
                console.log(error);
                if(!$this.map) $this.loadMapa({latitude: 19.34735, longitude: -99.12989});
            });
        }
            $this.loadMapa({latitude: 19.34735, longitude: -99.12989});
    }

    deleteMarker = () => {
        //this.markerList = this.lista;
        for (let i = 0; i < this.markerList.length; i++) {
            this.markerList[i].data.mostrar = false;
            this.markerList[i].setMap(null);
        }
        this.markerList = [];
        //console.log(this.markerList);
    }

    servicioMedicoFiltrado = () => {
        if(!this.props.marcadoresFlag){
            this.hidePoint();
            let $this = this;
            let filtros = this.props.filtrosM;

            this.deleteMarker();

            this.markerList.map((item, i) => {
                item.mostrar = true;
                item.setMap(null);
            });

            this.props.listaMedicos.map((item, i) => {
                this.addMarker(item);
            });


            this.markerList.map((item, i) => {
                if(item.data.mostrar){
                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.especialidad == 0 && filtros.circulo == 0){
                        item.setMap($this.map);
                    }

                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.especialidad == 0 && filtros.circulo == 0){
                        if(item.data.idestado == filtros.estado){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.especialidad > 0 && filtros.circulo == 0){
                        if(item.data.idespecialidad == filtros.especialidad){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.especialidad == 0 && filtros.circulo > 0){
                        if(item.data.idcirculo == filtros.circulo){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.especialidad == 0 && filtros.circulo == 0){
                        if(item.data.idmunicipio == filtros.municipio){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.especialidad > 0 && filtros.circulo > 0){
                        if(item.data.idespecialidad == filtros.especialidad && item.data.idcirculo == filtros.circulo){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.especialidad > 0 && filtros.circulo == 0){
                        if(item.data.idespecialidad == filtros.especialidad && item.data.idestado == filtros.estado){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.especialidad == 0 && filtros.circulo > 0){
                        if(item.data.idcirculo == filtros.circulo && item.data.idestado == filtros.estado){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.especialidad > 0 && filtros.circulo == 0){
                        if(item.data.idespecialidad == filtros.especialidad && item.data.idmunicipio == filtros.municipio){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.especialidad == 0 && filtros.circulo > 0){
                        if(item.data.idcirculo == filtros.circulo && item.data.idmunicipio == filtros.municipio){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.especialidad > 0 && filtros.circulo > 0){
                        if(item.data.idcirculo == filtros.circulo && item.data.idestado == filtros.estado && item.data.idespecialidad == filtros.especialidad){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.especialidad > 0 && filtros.circulo > 0){
                        if(item.data.idcirculo == filtros.circulo && item.data.idmunicipio == filtros.municipio && item.data.idespecialidad == filtros.especialidad){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }
                }
            });
            
            this.map.setZoom(8);
        }
    }

    servicioHospitalesFiltrado = () => {

        if(!this.props.marcadoresFlag){
            this.hidePoint();
            let $this = this;

            //this.markerList = [];

            let filtros = this.props.filtrosH;

            //this.markerList = [];
            this.deleteMarker();

            this.markerList.map((item, i) => {
                item.setMap(null);
            });

            this.props.listaHospitales.map((item, i) => {
                item.mostrar = true;
                this.addMarker(item);
            });

            this.markerList.map((item, i) => {
                if(item.data.mostrar){
                    //item.setMap($this.map);
                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.plan == 0){
                        item.setMap($this.map);
                    }

                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.plan == 0){
                        if(item.data.idestado == filtros.estado){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado == 0 && filtros.municipio == 0 && filtros.plan > 0){
                        if(item.data.idplan == filtros.plan){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }

                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.plan == 0){
                        if(item.data.idestado == filtros.estado && item.data.idmunicipio == filtros.municipio){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }


                    if(filtros.estado > 0 && filtros.municipio == 0 && filtros.plan > 0){
                        if(item.data.idestado == filtros.estado && item.data.idplan == filtros.plan){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }


                    if(filtros.estado > 0 && filtros.municipio > 0 && filtros.plan > 0){
                        if(item.data.idestado == filtros.estado && item.data.idmunicipio == filtros.municipio && item.data.idplan == filtros.plan){
                            item.setMap($this.map);
                        }else{
                            item.setMap(null);
                        }
                    }
                }else{
                    console.log("NO mostrar");
                    item.setMap(null);
                }
                
            });

            this.map.setZoom(8);
        }
    }

    

    render() {
        return (
            <div>
                <div id="map" style={{width: "100%"}}>
                    <div className="spinner">
                        {/*<img src={require("../img/spinner_90.gif")} alt="" />*/}
                        <div className="loading">
    						<div className="gnp-loading">
    							<div className="circle-orange"></div>
    							<div className="circle-blue"></div>
    							<div className="logo">
    								<svg xmlns="http://www.w3.org/2000/svg" width="94" height="70" viewBox="0 0 94 1">
    									<g fill="none">
    										<path fill="#183D7B" d="M42.086 16.762c0-.964.174-1.308-.915-1.882l-.754-.368v-.665h7.512v.665l-.766.299c-1.136.46-1.136.585-1.112 1.951l.011 5.498-.278.264c-1.31.333-4.37 1.159-7.13 1.159-6.328 0-9.446-3.248-9.446-10.272 0-7.553 4.405-10.824 10.189-10.824 1.553 0 4.37 0 6.329 1.642.65.54.707 1.147.707 1.388 0 .46-.093.551-.185.735l-1.403 2.697h-.522c0-1.331-1.564-4.878-5.633-4.878-4.718 0-4.95 3.26-4.95 8.769 0 4.82.51 9.159 6.144 9.159 1.82 0 2.156-.952 2.202-2.02v-3.317M49.806 22.615l1.345-.539c1.101-.425 1.101-1.217 1.101-2.973V6.443c0-.975-.278-1.457-1.043-1.973l-1.229-.815v-.666h5.576l.336.207c.614.815 1.89 3.007 3.605 5.302l5.912 7.966c.244.332.371.482.487.482.243 0 .243-.299.243-.85v-9.63c0-1.388-.023-1.663-1.217-2.145l-1.75-.666v-.666h7.013v.666l-.893.333c-1.31.516-1.564.815-1.564 2.812v11.936c0 1.825.034 3.673.034 4.304l-.208.241h-1.716l-.336-.24c-.278-.334-1.867-2.549-3.49-4.695l-7.163-9.48c-.394-.517-.58-.792-.73-.792-.279 0-.279.31-.279.734v10.835c0 1.457 0 1.917 1.287 2.341l1.808.631v.666h-7.129v-.666M71.982 22.615l1.344-.447c1.009-.333 1.043-.884 1.043-2.789V6.283c0-1.446 0-1.813-1.043-2.146l-1.344-.482v-.666h10.143c3.547 0 7.024.758 7.024 5.36 0 4.212-3.176 6.818-8.137 6.818-.21 0-.487-.035-.672-.035l-.453-1.09.244-.241c2.226-.057 4.926-.964 4.544-5.222-.302-3.317-1.276-3.937-4.022-3.937-1.867 0-1.994.275-1.994 1.033v13.704c0 2.031-.035 2.456 1.193 2.789l1.589.447v.666h-9.46v-.666M29.208 26.502h64.468v-.5H29.208z"/>
    										<path fill="#FF6F20" d="M16.619 13.032c0 1.87-1.53 3.386-3.431 3.386-1.89 0-3.42-1.515-3.42-3.386 0-1.871 1.53-3.386 3.42-3.386 1.9 0 3.43 1.515 3.43 3.386M7.496 7.373H.1l1.496 4.534h3.686v-.011c3.733 0 6.758-2.996 6.77-6.703V1.554L7.496.074v7.3M7.473 18.679v7.31l4.579-1.468v-3.65h-.012c0-3.696-3.025-6.691-6.77-6.703H1.596L.1 18.678h7.373M18.89 18.69h7.396l-1.507-4.522h-3.686c-3.732.012-6.758 3.007-6.758 6.703v3.638l4.556 1.48V18.69M18.902 7.396V.086l-4.567 1.468v3.65c.012 3.696 3.037 6.692 6.77 6.703h3.674l1.507-4.51h-7.384"/>
    										<path fill="#183D7B" d="M91.99 3.712v.276h-.302v.55h.302v.402l-.082-.126h-.22v.826h-.36V3.712h.662zm0 2.342c-.72 0-1.299-.574-1.299-1.366 0-.804.58-1.366 1.299-1.366v-.333c-.951 0-1.716.758-1.716 1.699 0 .93.765 1.687 1.716 1.687v-.321zm0-1.114V4.54H92c.22 0 .394-.035.394-.287 0-.23-.209-.264-.383-.264h-.022v-.276h.057c.464 0 .719.16.719.563 0 .332-.197.493-.51.516l.522.85h-.371l-.417-.7zm0-1.618c.706 0 1.286.562 1.286 1.366 0 .792-.58 1.366-1.286 1.366v.32c.938 0 1.703-.756 1.703-1.686a1.7 1.7 0 0 0-1.703-1.699v.333zM30.762 34.992c-.724 0-1.173-.203-1.339-.296-.15-.172-.252-.733-.252-1.264.055-.101.236-.109.3-.023.157.507.685 1.224 1.354 1.224.583 0 .85-.397.85-.787 0-.632-.598-1.006-1.07-1.24-.567-.28-1.19-.749-1.19-1.52-.008-.882.686-1.49 1.828-1.49.26 0 .582.031.897.125.103.03.174.046.268.062.063.172.142.593.142 1.115-.04.094-.236.102-.307.024-.134-.398-.473-.967-1.04-.967-.52 0-.803.335-.803.725 0 .359.323.686.716.889l.52.273c.489.257 1.11.71 1.11 1.567 0 .96-.795 1.583-1.984 1.583M39.173 31.748c0 .219.008.234.22.234h.544c.41 0 .504-.054.583-.429l.04-.195c.054-.062.251-.062.29.008-.015.25-.023.53-.023.827 0 .296.008.577.024.826-.04.07-.237.078-.292.008l-.04-.195c-.078-.374-.172-.437-.582-.437h-.543c-.213 0-.22.008-.22.242v.928c0 .359.03.608.125.74.103.141.252.204.827.204.685 0 .953-.024 1.386-.905.063-.086.26-.055.292.04-.032.404-.22 1.036-.331 1.247a58.632 58.632 0 0 0-1.82-.024H38.63c-.378 0-.764.008-1.355.024-.063-.047-.063-.234 0-.273l.37-.055c.355-.054.402-.101.402-.819v-2.908c0-.71-.047-.757-.402-.827l-.197-.039c-.07-.046-.063-.226.016-.273.37.016.756.024 1.134.024h1.67c.504 0 .953-.008 1.055-.024.008.125.063.687.103 1.209-.032.086-.213.101-.292.031-.086-.273-.197-.507-.3-.616-.149-.148-.385-.242-.77-.242h-.63c-.26 0-.26.016-.26.305v1.364M51.215 33.986c0 .328.015.484.165.515.032.031.024.164-.024.187-.133.023-.338.047-.55.117-.276.086-.954.187-1.395.187-.535 0-.992-.055-1.551-.273-.922-.367-1.552-1.232-1.552-2.355 0-.975.441-1.832 1.386-2.355.536-.288 1.174-.413 1.843-.413.874 0 1.308.187 1.56.187.023.234.031.78.11 1.256-.032.085-.244.093-.3.015-.251-.733-.748-1.1-1.48-1.1-1.252 0-1.859 1.03-1.859 2.262 0 1.115.386 1.778.898 2.121.378.25.788.296 1.08.296.448 0 .543-.086.543-.592v-.492c0-.42-.048-.468-.426-.522l-.346-.047c-.087-.047-.087-.226 0-.273.559.016.945.024 1.33.024.379 0 .765-.008 1.032-.024.063.047.063.226 0 .273l-.18.031c-.237.04-.284.117-.284.538v.437M56.806 30.844c0-.726-.047-.772-.401-.843l-.197-.039c-.063-.046-.071-.218.015-.265a28.095 28.095 0 0 0 2.3 0c.063.047.063.219 0 .265l-.189.032c-.354.062-.402.124-.402.85v1.8c0 .913.103 1.92 1.3 1.92 1.008 0 1.315-.874 1.315-1.942v-.944c0-.632-.031-1.224-.118-1.427-.07-.164-.244-.21-.457-.25l-.212-.039c-.063-.062-.048-.218 0-.265.425.016.732.024 1.055.024.291 0 .583-.008.882-.024.047.047.063.203 0 .265l-.142.032c-.205.047-.354.093-.425.257-.087.203-.118.795-.118 1.427v.873c0 .733-.071 1.404-.504 1.88-.347.366-.922.561-1.56.561-.598 0-1.134-.094-1.559-.437-.41-.335-.583-.912-.583-1.762v-1.95M67.927 31.974c0 .273.023.297.488.297.283 0 .449-.07.598-.219.134-.132.284-.382.284-.842 0-.702-.418-1.154-1.032-1.154-.323 0-.338.023-.338.398v1.52zm-1.08-.99c0-.78-.015-.866-.346-.912l-.213-.031c-.079-.04-.079-.234.016-.274.59-.039 1.205-.07 1.953-.07.67 0 1.244.102 1.544.281.457.265.693.655.693 1.154 0 .694-.473.99-.835 1.17-.079.039-.079.086-.04.171.52 1.045.843 1.63 1.221 1.95a.97.97 0 0 0 .528.218c.07.039.07.156.032.203-.126.054-.378.07-.623.07-.724 0-1.18-.257-1.528-.819a9.7 9.7 0 0 1-.614-1.208c-.094-.21-.22-.273-.417-.273-.276 0-.291.015-.291.171v.96c0 .717.047.771.401.834l.213.039c.055.039.055.226 0 .273a28.676 28.676 0 0 0-2.307 0c-.064-.047-.064-.234 0-.273l.212-.04c.354-.062.402-.116.402-.834v-2.76zM78.18 29.955c-.968 0-1.488.897-1.488 2.199 0 .951.339 2.48 1.622 2.48 1.032 0 1.433-.999 1.433-2.262 0-1.333-.59-2.417-1.567-2.417zm2.828 2.316c0 1.7-1.15 2.721-2.844 2.721-1.582 0-2.732-1.03-2.732-2.659 0-1.544 1.165-2.737 2.811-2.737 1.638 0 2.765 1.092 2.765 2.675zM87.268 34.992c-.724 0-1.173-.203-1.338-.296-.15-.172-.252-.733-.252-1.264.055-.101.236-.109.3-.023.157.507.684 1.224 1.353 1.224.583 0 .851-.397.851-.787 0-.632-.598-1.006-1.07-1.24-.568-.28-1.19-.749-1.19-1.52-.008-.882.685-1.49 1.827-1.49.26 0 .583.031.898.125.102.03.173.046.267.062.064.172.142.593.142 1.115-.039.094-.236.102-.307.024-.133-.398-.472-.967-1.04-.967-.52 0-.803.335-.803.725 0 .359.323.686.717.889l.52.273c.488.257 1.11.71 1.11 1.567 0 .96-.795 1.583-1.985 1.583"/>
    									</g>
    								</svg>
    							</div>
    						</div>
    					</div>
                    </div>
                </div>
                { this.props.paso == 2 && this.props.servicio == "medicos" && this.props.filtrosM && !this.props.marcadoresFlag && 
                    <div>
                        { this.servicioMedicoFiltrado() }
                    </div>
                }
                { this.props.paso == 2 && this.props.servicio == "hospitales" && this.props.filtrosH && !this.props.marcadoresFlag &&
                    <div>
                        { this.servicioHospitalesFiltrado() }
                    </div>
                }
                { this.props.paso == 2 && this.props.seleccionado && 
                    <div>
                        { this.getPoint() }
                    </div>
                }
                {this.props.paso < 2 && this.deleteMarker() && this.changeZoom()}
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Mapa);



// WEBPACK FOOTER //
// ./src/directorio/mapa.cmpt.js